import React, { useContext } from 'react';

import { Container } from 'components/common';
import { Link } from 'gatsby';
import { LangContext } from 'providers/LangProvider';
import NavbarLinks from '../NavbarLinks';
import { Brand, Wrapper } from './styles';

const Navbar = () => {
  const { lang } = useContext(LangContext);

  return (
    <Wrapper as={Container}>
      <Brand as={Link} to={lang === 'is' ? '/' : '/en/'}>
        Hindisvík
      </Brand>
      <NavbarLinks desktop />
    </Wrapper>
  );
};

export default Navbar;
